// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.payment.PaymentDashboardSearchByReferenceRequest */
/* istanbul ignore next */
@GandalfModel
export class PaymentDashboardSearchByReferenceRequest extends GandalfModelBase {

	@GandalfLabel('Reference #')
	@GandalfValidator({ sizeString: { fieldLabel: 'Reference #', maxLength: 1000, minLength: 1, message: 'Reference # must be between 1 and 1000 characters' } })
	@GandalfValidator({ notNull: { message: 'Reference # is required' } })
	@GandalfProperty({ designType: String, isRequired: true })
	referenceNumber!: string;

}
